module.exports = __webpack_public_path__ + "img/Home-03.ba019c39.svg";